import { type RefObject, useCallback, useEffect, useState } from "react";
export const useScroll = <T extends HTMLElement>(ref: RefObject<T>) => {
  const [scroll, setScroll] = useState(false);

  const _set = useCallback((target: T) => {
    setScroll(target.scrollTop > 0);
  }, []);

  const cb = useCallback((event: Event) => {
    _set(event.currentTarget as T);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const el = ref.current;

    if (el != null) {
      el.addEventListener("scroll", cb, { passive: true });
      _set(el);
      return () => {
        el.removeEventListener("scroll", cb);
      };
    }

    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return scroll;
};
